<template>
    <Modal
        title="确认撤回"
        :value="modalCancelVisible"
        :mask-closable="false"
        :width="500"
        @on-visible-change = changeCancelVisible>
        <Form ref="cancelForm"  :model="cancelForm" :label-width="70">
            <FormItem label="撤回原因">
                <Input
                    type="textarea"
                    :maxlength="1000"
                    v-model="cancelForm.reason"
                    :rows="4"/>
            </FormItem>
        </Form>
        <div slot="footer">
            <Button type="text" @click="cancel('cancelForm')">取消</Button>
            <Button type="primary" :loading="submitLoading" @click="handelSubmitCancel">提交</Button>
        </div>
    </Modal>
</template>
<script>
import { cancelApply} from "@/api/activiti";
export default {
    props:{
        modalCancelVisible:{
            type:Boolean,
            required:true
        },
        id:{ //撤回id
            type:String,
            required:true
        },
        procInstId:{ //流程id
            type:String,
            required:true
        },
        businessType:{
            type:String,
            required:true
        }
    },
    data(){
        return{
            submitLoading:false,
            cancelForm:{
                id:'',
                procInstId:'',
                reason: "",//撤回原因
                businessType:'',//类型
            }
            
        }
    },
    methods:{
        changeCancelVisible(v){
        	if(!v){
        		this.cancelForm.reason = ""
        	}
            this.$emit('cancel',v)
        },
        handelSubmitCancel() {
            this.submitLoading = true;
            this.cancelForm.id = this.id;
            this.cancelForm.procInstId = this.procInstId;
            this.cancelForm.businessType = this.businessType
            cancelApply(this.cancelForm).then((res) => {
                this.submitLoading = false;
                if (res.success === true) {
                    this.$Message.success("撤销成功");
                    this.$emit('refresh')
                    this.$emit('cancel',false)
                }
            });
        },
        cancel(name){
            this.cancelForm = this.$options.data().cancelForm
            this.$refs[name].resetFields();
            this.$emit('cancel',false)
        }
    }
}
</script>